var BufferFormatter = require('bufferformatter');


var BufferListBufferView = Backbone.View.extend({
    sidebar: $('#sidebar'),
    initialize: function (options) {
        this.formatter = new BufferFormatter(this.model);
    },
    events: {
        'click span.buffer': 'click',
        'buttonClick span.buffer': 'click'
    },
    click: function (e) {
        e.preventDefault();
        this.model.session.trigger('sidebarBufferClick', this.model);
        this.model.select();
    },
    getTemplate: function () {
        if (!BufferListBufferView._structure) {
            BufferListBufferView._structure = $($('#tpl-buffer-link').html());
        }
        return BufferListBufferView._structure.clone();
    },
    render: function () {
        this.link = this.getTemplate();

        var lockTitle;
        if (this.model.connection.isSlack()) {
            lockTitle = "Private channel";
        } else {
            lockTitle = "Password protected";
        }
        this.link.find('.fa-lock').attr('title', lockTitle);

        this.linkLabel = this.link.find('.label');
        this.renderLink();
        
        this.renderActive().renderSelected().renderUnread().renderHighlights().renderDeferred().renderTimeout();
        this.model.bind('selectedChange', this.renderSelected, this);
        this.model.bind('change:deferred', this.renderDeferred, this);
        this.model.bind('change:timeout', this.renderTimeout, this);
        this.model.bind('activeChange', this.renderActive, this);
        this.model.bind('unseenChange', this.renderUnread, this);
        this.model.bind('prefChange:disableTrackUnread', this.renderUnread, this);
        this.model.bind('unseenHighlightChange', this.renderHighlights, this);
        this.model.bind('remove', this.remove, this);
        this.model.on('rendered', this.containerRendered, this);
        
        this.$el.append(this.link);

        if (this.model.isPinned()) {
            this.$el.data('bid', this.model.bid());
        }
        
        return this;
    },
    renderLink: function () {
        return this.renderLinkUrl().renderLinkText();
    },
    setLinkLabelHtml: function (html) {
        this.linkLabel[0].innerHTML = html;
    },
    renderDeferred: function () {
        this.$el.toggleClass('deferred', this.model.isDeferred());
        return this;
    },
    renderTimeout: function () {
        this.$el.toggleClass('timeout', this.model.isTimeout());
        return this;
    },
    renderUnread: function () {
        if (this.model.isTrackingUnread()) {
            this.$el.removeClass('ignoredUnread');
            this.$el.toggleClass('unread', this.model.hasUnseen());
        } else {
            this.$el.removeClass('unread');
            this.$el.toggleClass('ignoredUnread', this.model.hasUnseen());
        }
        return this;
    },
    renderHighlights: function () {
        if (this.model.hasUnseenHighlights()) {
            this.link.find('.badge').text(this.model.unseenHighlightCount());
            this.$el.addClass('activeBadge');
        } else {
            this.link.find('.badge').text('');
            this.$el.removeClass('activeBadge');
        }
        
        return this;
    },
    containerRendered: function () {
        this.link.attr({
            'aria-controls': 'buffercontainer_' + this.model.bid()
        });
    },
    scrollToView: function () {
        this.trigger('scrollTo', this.$el);
    },
    renderSelected: function () {
        var selected = this.model.isSelected();
        this.$el.toggleClass('selected', selected);
        this.link.attr('aria-selected', String(selected));
        return this;
    },
    renderActive: function () {
        this.$el.toggleClass('active', this.model.isActive());
        return this;
    }
});


module.exports = BufferListBufferView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/model/bufferlistbufferview.js
// module id = VFp6
// module chunks = 1